import adminApiClient from '../api/adminApiClient'
import type { ActivityTodayResponse } from '../types'

export async function getActivityToday(): Promise<ActivityTodayResponse> {
  const { data } = await adminApiClient.get<ActivityTodayResponse>('/activity/today')
  return data
}
